import Api from '@/api/api';

export default {
    // addTenant(tenantDetails) {
    //     return Api.post('saasAdmin/api/TenantConfig/Tenant', tenantDetails);
    // },
    addTenantDtls(tenantDetails) {
        return Api.post('saasAdmin/api/TenantConfig/Save', tenantDetails);
    },
    updateTenant(tenantID, tenantDetails) {
        return Api.put(`saasAdmin/api/TenantConfig/Tenant/${tenantID}`, tenantDetails);
    },
    // addUsers(tenantID, tenantDetails) {
    //     return Api.post(`saasAdmin/api/TenantConfig/AddBulkTenantUser/${tenantID}`, tenantDetails);
    // },
    addUserDtls(tenantDetails) {
        return Api.post(`saasAdmin/api/TenantConfig/Save`, tenantDetails);
    },
    removeUsers(tenantID, users) {
        return Api.post(`saasAdmin/api/TenantConfig/DeleteBulkTenantUser/${tenantID}`, users);
    },
    // addProduct(tenantID, productDetails) {
    //     return Api.post(`saasAdmin/api/TenantConfig/SaveBulkTenantProduct/${tenantID}`, productDetails)
    // },
    addProd(ProductID, PackageID) {
        return Api.get(`saasAdmin/api/TenantConfig/ProductFeatureMap//${ProductID}/${PackageID}`)
    },
    addProducts(productDetails) {
        return Api.post(`saasAdmin/api/TenantConfig/Save`, productDetails);
    },
    saveAddons(tenantID, addons) {
        return Api.post(`saasAdmin/api/TenantConfig/AddBulkTenantFeatureMap/${tenantID}`, addons)
    },
    saveVendors() {
        return { data: { success: true, result: [] } }
    },
    removeVendors() {
        return { data: [] }
    },
    removeAddons(tenantID, addons) {
        return Api.post(`saasAdmin/api/TenantConfig/DeleteBulkTenantFeatureMap/${tenantID}`, addons)
    },
    saveDatabase() { },
    saveConfigProfile(tenantID, profileID) {
        return Api.put(`saasAdmin/api/TenantConfig/Tenant/${tenantID}/${profileID}`)
    },
    saveSaasConfig(tenantID, config) {
        return Api.post(`saasAdmin/api/TenantConfig/BulkTenantSetting/${tenantID}`, config)
    },
    loadSaasConfig() {
        return Api.get('/SaasAdmin/api/TenantConfig/TenantSetting/Defaults')
    },
    createDefaultConfig() {
        return Api.post('/saasAdmin/api/ConfigurationProfile')
    },
    createProfileConfig(tenantID, profile) {
        return Api.post(`/saasAdmin/api/ConfigurationProfile/${tenantID}`, profile)
    },
    activateTenant(tenantID) {
        return Api.post(`/saasAdmin/api/TenantConfig/CreateAccount/${tenantID}`)
    },
    activateTenantDtls(tenantDetails) {
        return Api.post('saasAdmin/api/TenantConfig/SaveAndActivate', tenantDetails);
    },
    saveBulkDBConfig(config) {
        return Api.post(`saasAdmin/api/bulkConfigDBDetail`, config)
    },
    loadTenant(tenantID, configProfileID) {
        return Promise.all(
            [
                Api.get(`saasAdmin/api/TenantConfig/AllTenantDetails/${tenantID}`),
                configProfileID ? Api.get(`/saasAdmin/api/configurationProfile/${configProfileID}`) : Promise.resolve({ data: null }),
            ]
        )
    },
    removeTenant(tenantID) {
        return Api.delete(`saasAdmin/api/TenantConfig/Tenant/${tenantID}`)
    },
    testConnection(connectionString) {
        return Api.post(`saasAdmin/api/TenantConfig/TestConnectionString?ConnectionString=${connectionString}`)
    },
    tenantActivation(data){
       return Api.post(`saasAdmin/api/TenantConfig/SetTenantActivationStatus?TenantID=${data.tenantID}&isActivated=${data.isActivated}`)
    },
    getAuditLogs(tenantId, pageSize, pageNo){
        return Api.get(`SaasAdmin/api/TenantConfig/GetAuditLog?Id=${tenantId}&pageSize=${pageSize}&pageNo=${pageNo}`);
    }
}
